module.exports = __webpack_public_path__ + "img/zhuanzhang.f01f7bd4.png";